import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AppActions, AppSelectors } from 'store/App';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { toast } from 'components/Snackbar';

import type { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

export function ToastErrorHandler({ children }: Props) {
  const { t } = useTranslation();
  const errors = useAppSelector(AppSelectors.selectErrors);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const latestError = errors.at(0);

    if (!latestError) return;

    toast({
      type: 'error',
      titleKey: 'common.error',
      textBody: latestError || t('errors.unexpectedError'),
      onShow: () => {
        dispatch(AppActions.dequeueError());
      },
    });
  }, [errors]);

  return <>{children}</>;
}
